var carouselPosition = 0
var width = window.innerWidth
var container = document.querySelectorAll('.endy-carousel-container')

// document.addEventListener('DOMContentLoaded', function () {
// 	initSlider(container)
// })

// window.addEventListener('resize', function (e) {
// 	var newWidth = window.innerWidth
// 	if (width !== newWidth) {
// 		for (var i = 0; i < container.length; i++) {
// 			resizeLayout(container[i])
// 			width = newWidth
// 		} 
// 	} 
// }) 

// TODO: Refactor so position = 0 by default if no argument is passed
function initSlider(container, position) {
	if (position !== undefined) {
		carouselPosition = position
		// Reset Thumbnails
		setThumbnailToActive(carouselPosition)
	}
	for (var i = 0; i < container.length; i++) {
		sliderLayout(container[i])
	}
}

function sliderLayout(carousel) {
	const currentSlide = carousel.children ? carousel.children[carouselPosition] : null
	currentSlide.classList.add('active')

	var width = carousel.parentElement.clientWidth

	carousel.setAttribute('style', 'width:' + width + 'px;transform:translateX(' + carouselPosition * width + 'px);')

	for (var j = 0; j < carousel.children.length; j++) {
		var item = carousel.children[j]
		var childWidth = setSize(item.children[0])
		if (childWidth === 0 || childWidth === undefined) {
			childWidth = width
		}
		item.setAttribute('style', 'width:' + width + 'px;left:' + width * (j - carouselPosition) + 'px;')
		// item.children[0].setAttribute('style', 'width:' + childWidth + 'px')
	}
	currentSlide && loadImage(currentSlide.children[0])
	setUpNav(carousel)
}

function resizeLayout() {
	var width = document.querySelector('.endy-carousel').getBoundingClientRect().width
	var carousel = document.querySelector('.endy-carousel-container')
	carousel.setAttribute('style', 'width:' + width + 'px;transform:translateX(' + carouselPosition * width + 'px);')
	for (var j = 0; j < carousel.children.length; j++) {
		var item = carousel.children[j]
		item.setAttribute('style', 'width:' + width + 'px;left:' + width * (j - carouselPosition) + 'px;')
		for (var i = 0; i < item.children.length; i++) {
			// don't set placeholder image width
			if (!item.children[i].classList.contains('placeholder')) {
				item.children[i].setAttribute('style', 'width:' + setSize(item.children[i]) + 'px')
			}
		}
	}
}

function setUpNav(container) {
	internalNav(container)
}

function internalNav(container) {
	//
	var numOfSlides = document.getElementsByClassName('endy-carousel-item').length

	// Thumbnail Nav
	var thumbnails = document.querySelectorAll('.carousel-thumbnail-link')

	// Get parent
	var incrementalNavContainer
	if (document.querySelector('.endy-carousel-nav-container') === null) {
		incrementalNavContainer = document.createElement('div')
		incrementalNavContainer.classList.add('endy-carousel-nav-container')
		incrementalNavContainer.appendChild(createIncrementalButton(carouselPosition - 1, 'prev'))
		incrementalNavContainer.appendChild(createIncrementalButton(carouselPosition + 1, 'next'))
		container.parentElement.appendChild(incrementalNavContainer)
	} else {
		incrementalNavContainer = document.querySelector('.endy-carousel-nav-container')
		if (carouselPosition === 0) {
			document.querySelector('.endy-carousel-nav-container .next').setAttribute('to', carouselPosition + 1)
			document.querySelector('.endy-carousel-nav-container .prev').setAttribute('to', carouselPosition - 1)
			document.querySelector('.endy-carousel-nav-container .prev').classList.add('hidden')
			for (var i = 0; i < thumbnails.length; i++) {
				thumbnails[i].setAttribute('to', i)
			}
		}
	}

	var startPos
	var startY
	var offsetStartPos
	var lastPos
	var lastY
	var touchEvent = false

	function moveStart(event) {
		startPos = event.touches[0].clientX
		startY = event.touches[0].clientY
		offsetStartPos = returnTransformX(window.getComputedStyle(container).getPropertyValue('transform'))
	}

	function moveListener(event) {
		var amount
		lastPos = event.touches[0].clientX
		lastY = event.touches[0].clientX
		if (lastY > startY) { // DOWN
			// console.log('DOWN')
		} else if (lastY < startY) { // UP
			// console.log('UP')
		}
		document.querySelector('body').style.position = 'fixed'
		container.classList.remove('animate')
		if (startPos > (lastPos + 25)) { // MOVE TO THE LEFT
			amount = (startPos - offsetStartPos) - lastPos
			if (!isNaN(amount)) {
				container.setAttribute('style', 'transform:translateX(' + -amount + 'px)')
				touchEvent = true
			}
		} else if (startPos < (lastPos + 25)) {
			amount = offsetStartPos + lastPos - startPos
			if (!isNaN(amount)) {
				container.setAttribute('style', 'transform:translateX(' + amount + 'px)')
				touchEvent = true
			}
		}
	}

	function moveEnd(event) {
		document.querySelector('body').style.position = 'relative'
		container.classList.remove('mirco-animate')
		container.classList.add('animate')
		var amountMoved
		if (touchEvent === true) {
			if (lastPos > startPos) { // MOVE TO THE LEFT
				if (carouselPosition === 0) {
					container.style.transform = 'translateX(0px)'
				} else {
					amountMoved = offsetStartPos + lastPos - startPos
					moveCarousel(event, amountMoved + offsetStartPos, (container.clientWidth - amountMoved), 'prev')
				}
			} else if (lastPos < startPos) {
				if (carouselPosition === numOfSlides - 1) {
					container.style.transform = 'translateX(' + -(container.clientWidth * (numOfSlides - 1)) + 'px)'
				} else {
					amountMoved = ((startPos - offsetStartPos) - lastPos) * -1
					moveCarousel(event, amountMoved + offsetStartPos, -(amountMoved + container.clientWidth), 'next')
				}
			}
			touchEvent = false
		}
	}

	incrementalNavContainer.addEventListener('touchstart', moveStart, {
		passive: true
	})
	incrementalNavContainer.addEventListener('touchmove', moveListener, {
		passive: true
	})
	incrementalNavContainer.addEventListener('touchend', moveEnd, {
		passive: true
	})

	for (var i = 0; i < thumbnails.length; i++) {
		thumbnails[i].addEventListener('click', function () {
			var index = this.getAttribute('to')
			var currentTransformX = returnTransformX(window.getComputedStyle(this.parentElement.parentElement.parentElement.querySelector('.endy-carousel-container')).getPropertyValue('transform'))
			moveCarousel(event, currentTransformX, -((container.clientWidth * index)) - currentTransformX)
		})
	}
}

function moveSlideByXAmount(direction, parentElement) {
	var amount = parentElement.querySelector('.endy-carousel-container').clientWidth
	if (direction === 'next') {
		amount = amount * -1
	}
	var currentTransformX = returnTransformX(window.getComputedStyle(parentElement.querySelector('.endy-carousel-container')).getPropertyValue('transform'))
	moveCarousel(event, currentTransformX, amount)
}

function createIncrementalButton(nextPosition, direction) {
	var button = document.createElement('button')
	if (direction === 'prev') {
		button.classList.add('hidden')
		button.setAttribute('aria-label', 'Previous product image slide.')
	} else {
		button.setAttribute('aria-label', 'Next product image slide.')
	}
	button.classList.add(direction)
	button.classList.add('incremental-button')
	button.classList.add('btn--reset')
	button.setAttribute('to', nextPosition)
	button.setAttribute('direction', direction)

	button.addEventListener('click', function () {
		moveSlideByXAmount(direction, this.parentElement.parentElement);
	})
	button.addEventListener('keypress', function (e) {
		if (e.key === "Enter") {
			e.preventDefault();
			moveSlideByXAmount(direction, this.parentElement.parentElement);
		}
	}) 
	return button
}

function returnTransformX(matrix) {
	var values = matrix.split('(')[1]
	values = values.split(')')[0]
	values = values.split(',')
	return parseFloat(values[4])
}

function setSize(image) {
	var ratioModifier = image.parentElement.clientHeight
	var width = image.clientWidth
	var height = image.clientHeight
	var ratio = width / height
	return ratioModifier * ratio
}

function duplicateElement(element) {
	// create parent
	var newElement = document.createElement(element.tagName)
	var elementAttributes = element.attributes
	for (var a = 0; a < elementAttributes.length; a++) {
		newElement.setAttribute(elementAttributes[a].name, elementAttributes[a].value)
	}
	for (var i = 0; i < element.children.length; i++) {
		var child = element.children[i]
		var attributes = child.attributes
		var newChild = document.createElement(child.tagName)
		for (var j = 0; j < attributes.length; j++) {
			newChild.setAttribute(attributes[j].name, attributes[j].value)
		}
		newElement.appendChild(newChild)
	}
	return newElement
}

function loadImage(image) {
	if (image.classList.contains('loaded')) {
		return
	}
	var imgLarge = new Image()
	imgLarge.src = image.getAttribute('data-zoom')
	imgLarge.classList.add('endy-carousel-image', 'transparent')
	imgLarge.setAttribute('alt', image.getAttribute('alt'))
	imgLarge.onload = function () {
		imgLarge.classList.add('loaded')
		image.classList.add('loaded')
	}
	image.parentElement.appendChild(imgLarge)
}

function moveCarousel(event, startAmount, amountToMove, direction) {
	var slides = document.getElementsByClassName('endy-carousel-item')

	if (event.type === 'click') {
		var slideToDisplay = parseInt(event.currentTarget.getAttribute('to'))
		// if the current slide is the same as the requested do nothing
		if (slideToDisplay === carouselPosition) {
			return
		}
		// SEND TO FRONT
		if (carouselPosition === (slides.length - 1) && amountToMove < 0) {} else if (carouselPosition === 0 && amountToMove > 0) { // SEND TO BACK
		} else {
			carouselPosition = parseInt(event.currentTarget.getAttribute('to'))
			next(slides, startAmount, amountToMove)
		}
	} else { // Swipe
		if (direction === 'prev') { // PREV
			carouselPosition = carouselPosition - 1
		} else { // NEXT
			carouselPosition = carouselPosition + 1
		}
		next(slides, startAmount, amountToMove)
	}
}

function next(slides, startAmount, amountToMove) {
	var slider = document.getElementsByClassName('endy-carousel-container')[0]
	animate(slider, startAmount, amountToMove)
	setThumbnailToActive(carouselPosition)
	loadImage(slides[carouselPosition].children[0])
	updateNavArrows(carouselPosition - 1, carouselPosition + 1)
}

function setThumbnailToActive(index) {
	var thumbnails = document.querySelectorAll('.carousel-thumbnail-link')
	for (var i = 0; i < thumbnails.length; i++) {
		thumbnails[i].classList.remove('active')
	}
	thumbnails[index].classList.add('active')
}

function updateNavArrows(prev, next) {
	var slides = document.getElementsByClassName('endy-carousel-item')
	var nextEle = document.querySelector('.next.incremental-button')
	var prevEle = document.querySelector('.prev.incremental-button')
	if (prev < 0) {
		prevEle.classList.add('hidden')
	} else if (prevEle.classList.contains('hidden')) {
		prevEle.classList.remove('hidden')
	}

	if (next > slides.length - 1) {
		nextEle.classList.add('hidden')
	} else if (nextEle.classList.contains('hidden')) {
		nextEle.classList.remove('hidden')
	}
	nextEle.setAttribute('to', next)
	prevEle.setAttribute('to', prev)
}

function animate(elem, startingAmount, slidesToMove) {
	var stop = parseFloat(slidesToMove + parseFloat(startingAmount))
	if (stop % elem.clientWidth === 0) {} else {
		if (stop > 0) {
			stop = elem.clientWidth
		} else {
			stop = -elem.clientWidth
		}
	}
	elem.classList.add('animate')
	elem.style.transform = 'translateX(' + stop + 'px)'
}

// function zoom () {

// }

// function changeVariant () {

// }